import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import VideoSceneEditor from '../components/VideoSceneEditor';

/** Full-page host for the video scene editor (/video/edit/:name). */
export default function VideoEditPage() {
  const { name } = useParams();
  // Keep the app's theme choice applied.
  useEffect(() => {
    const t = (typeof localStorage !== 'undefined' && localStorage.getItem('studio-theme')) === 'dark' ? 'dark' : 'light';
    document.documentElement.setAttribute('data-theme', t);
  }, []);
  if (!name) return null;
  return (
    <div style={{ position: 'relative', height: '100vh' }}>
      <VideoSceneEditor name={name} />
    </div>
  );
}
